import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './utilities/tabs';
import './utilities/accordion';
import './utilities/video-popup';
import './utilities/select-redirect';
import './header/sticky-header';
import './header/nav';
import './header/click-events';
import './header/announcement-bar';
import './sliders/hero-slider';
import './sliders/product-slider';
import './sliders/default-slider';
import './products/reviews';
import './products/click-events';
import './products/variants';
import './cart/update';
import './account/confirm-password';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
